import React from "react";
import { useSelector } from "react-redux";
import CardPaymentBanner from "../cardPaymentBanner/CardPaymentBanner";
import IntervendBanner from "./IntervendBanner";
import MyWashBanner from "./MyWashBanner";

const BannerContainer = () => {
  const user = useSelector((state) => state.auth.user);
  const banners = user?.banners || {};

  // Fallback: if banners not yet populated, use legacy showAd for cardPayment
  const showCardPayment = banners.cardPayment ?? user?.showAd;

  return (
    <>
      {showCardPayment && <CardPaymentBanner />}
      {banners.intervend && <IntervendBanner />}
      {banners.mywash && <MyWashBanner />}
    </>
  );
};

export default BannerContainer;
